/**
 * @generated SignedSource<<0fe1a5c6500f1112d6321610e608e53a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AgendaWaitlistBookings_Agenda$data = {
  readonly date: string;
  readonly facility: {
    readonly club: {
      readonly supportsPublic: boolean;
    } | null | undefined;
  };
  readonly id: string;
  readonly queueSlot: {
    readonly bookings: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly request?: {
            readonly time: string;
          } | null | undefined;
          readonly " $fragmentSpreads": FragmentRefs<"AgendaWaitlistBooking_Booking">;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly id: string;
    readonly queueCount: {
      readonly count: number;
    } | null | undefined;
  };
  readonly waitlistRestrictions: {
    readonly edges: ReadonlyArray<{
      readonly liftAt: string | null | undefined;
      readonly node: {
        readonly id: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "AgendaWaitlistBookings_Agenda";
};
export type AgendaWaitlistBookings_Agenda$key = {
  readonly " $data"?: AgendaWaitlistBookings_Agenda$data;
  readonly " $fragmentSpreads": FragmentRefs<"AgendaWaitlistBookings_Agenda">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Request",
    "kind": "LinkedField",
    "name": "request",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "time",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "courseIds"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "queueSlot",
          "bookings"
        ]
      }
    ]
  },
  "name": "AgendaWaitlistBookings_Agenda",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "date",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "QueueSlot",
      "kind": "LinkedField",
      "name": "queueSlot",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": "queueCount",
          "args": null,
          "concreteType": "BookingConnection",
          "kind": "LinkedField",
          "name": "bookings",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "count",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": "bookings",
          "args": [
            {
              "kind": "Literal",
              "name": "orderBy",
              "value": {
                "direction": "ASC",
                "field": "REQUESTED_DATE_TIME"
              }
            }
          ],
          "concreteType": "BookingConnection",
          "kind": "LinkedField",
          "name": "__queueSlot_bookings_connection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "BookingEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "kind": "InlineFragment",
                      "selections": (v1/*: any*/),
                      "type": "StandardBooking",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v1/*: any*/),
                      "type": "LessonBooking",
                      "abstractKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "AgendaWaitlistBooking_Booking"
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "__queueSlot_bookings_connection(orderBy:{\"direction\":\"ASC\",\"field\":\"REQUESTED_DATE_TIME\"})"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Facility",
      "kind": "LinkedField",
      "name": "facility",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Club",
          "kind": "LinkedField",
          "name": "club",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "supportsPublic",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "waitlistRestrictions",
      "args": [
        {
          "kind": "Variable",
          "name": "courseIds",
          "variableName": "courseIds"
        },
        {
          "kind": "Literal",
          "name": "type",
          "value": [
            "WAITLIST"
          ]
        }
      ],
      "concreteType": "AgendaBookingRulesConnection",
      "kind": "LinkedField",
      "name": "bookingRules",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AgendaBookingRulesEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "liftAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Agenda",
  "abstractKey": null
};
})();

(node as any).hash = "5b795054d52ddecd61fa540c69fe3074";

export default node;
